exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".GameIntro__back-button___195ux{position:absolute;top:20px;left:20px}.GameIntro__slide___1pj8U{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden}.GameIntro__slide___1pj8U>img{border:1000px solid rgba(0,0,0,.85);max-height:80vh}", "", {"version":3,"sources":["C:/Projects/presspauseplay/edf-power-map/src/ts/app/screens/game-intro/GameIntro.scss"],"names":[],"mappings":"AAAA,gCAAa,kBAAkB,SAAS,SAAS,CAAC,0BAAO,kBAAkB,WAAW,YAAY,aAAa,uBAAuB,mBAAmB,eAAe,CAAC,8BAAW,oCAAqC,eAAe,CAAC","file":"GameIntro.scss","sourcesContent":[".back-button{position:absolute;top:20px;left:20px}.slide{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden}.slide>img{border:1000px solid rgba(0,0,0,0.85);max-height:80vh}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"back-button": "GameIntro__back-button___195ux",
	"backButton": "GameIntro__back-button___195ux",
	"slide": "GameIntro__slide___1pj8U"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"modules":true,"importLoaders":1,"sourceMap":true,"localIdentName":"[name]__[local]___[hash:base64:5]","camelCase":true,"namedExport":true,"url":false}!./node_modules/sass-loader/lib/loader.js!./src/ts/app/screens/game-intro/GameIntro.scss
// module id = 182
// module chunks = 0